import { HistoryPesee } from './historyService';
import { ExportField } from '@/components/export/FieldSelector';
// Import PDF supprimé car non utilisé dans ce service

// Types pour jsPDF supprimés car non utilisés

// Import statique des modules PDF - variables supprimées car non utilisées

// Fonction loadPDFModules supprimée car non utilisée

// Types pour autoTable supprimés car non utilisés

// Interface pour les options d'export
export interface ExportOptions {
  fields: ExportField[];
  selectedFieldKeys: string[];
  filename?: string;
  title?: string;
}

class ExportService {
  /**
   * Exporter les pesées en PDF avec champs personnalisés
   */
  async exportToPDF(_weighings: HistoryPesee[], _options: ExportOptions): Promise<void> {
    // TODO: Implémenter l'export PDF pour les pesées
    console.warn('Export PDF pour les pesées non encore implémenté');
    throw new Error('Export PDF pour les pesées non encore implémenté');
  }

  /**
   * Exporter les pesées en Excel avec champs personnalisés
   */
  async exportToExcel(weighings: HistoryPesee[], options: ExportOptions): Promise<void> {
    const { fields, selectedFieldKeys, filename = 'pesees.xlsx' } = options;
    try {

      // Import dynamique de XLSX
      const XLSX = await import('xlsx');
     
      // Import dynamique de file-saver
      const { saveAs } = await import('file-saver');
      // Filtrer les champs sélectionnés
      const selectedFields = fields.filter(field => selectedFieldKeys.includes(field.key));
      
      // Préparer les données
      const data = weighings.map(weighing => {
        const row: Record<string, any> = {};
        selectedFields.forEach(field => {
          const value = field.getValue(weighing);
          row[field.label] = value;
        });
        return row;
      });

      // Créer le workbook
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      
      // Ajuster la largeur des colonnes dynamiquement
      const colWidths = selectedFields.map(field => {
        // Largeur par défaut basée sur le type de champ
        if (field.key.includes('observations') || field.key.includes('adresse')) {
          return { wch: 30 };
        } else if (field.key.includes('nom') || field.key.includes('chauffeur') || field.key.includes('client')) {
          return { wch: 20 };
        } else if (field.key.includes('date') || field.key.includes('heure')) {
          return { wch: 15 };
        } else if (field.key.includes('poids')) {
          return { wch: 12 };
        } else {
          return { wch: 15 };
        }
      });
      ws['!cols'] = colWidths;

      // Ajouter la feuille au workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Pesées');
      
      // Générer le fichier Excel
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      // Sauvegarder le fichier
      saveAs(dataBlob, filename);
      
    } catch (error) {
      console.error('Erreur détaillée lors de l\'export Excel:', error);
      throw new Error(`Erreur lors de l'export Excel: ${error instanceof Error ? error.message : 'Erreur inconnue'}`);
    }
  }

  /**
   * Exporter les pesées en CSV avec champs personnalisés
   */
  async exportToCSV(weighings: HistoryPesee[], options: ExportOptions): Promise<void> {
    const { fields, selectedFieldKeys, filename = 'pesees.csv' } = options;
    try {
      // Import dynamique de file-saver
      const { saveAs } = await import('file-saver');
      // Filtrer les champs sélectionnés
      const selectedFields = fields.filter(field => selectedFieldKeys.includes(field.key));
      // En-têtes
      const headers = selectedFields.map(field => field.label);

      // Données
      const data = weighings.map(weighing => 
        selectedFields.map(field => {
          const value = field.getValue(weighing);
          return String(value);
        })
      );

      // Créer le contenu CSV
      const csvContent = [headers, ...data]
        .map(row => row.map(field => `"${field}"`).join(','))
        .join('\n');

      // Créer et télécharger le fichier
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, filename);
      
    } catch (error) {
      throw new Error(`Erreur lors de l'export CSV: ${error instanceof Error ? error.message : 'Erreur inconnue'}`);
    }
  }

  /**
   * Générer un nom de fichier avec timestamp
   */
  generateFilename(prefix: string, extension: string): string {
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
    return `${prefix}_${timestamp}.${extension}`;
  }
}

export default new ExportService();
